import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import {
  useFilterByCategory,
  useFilterByBrand,
  useSizeFilter,
  Alert,
} from "../../utils";
import {
  SearchBar,
  FilterByBrand,
  FilterBySize,
  FilterByCategory,
  SelectedOption,
  ViewDetailsRow,
} from "../index";
import style from "./Filters.module.css";

const Filters = ({ selected, setSelected, userPro, insertModal }) => {
  const { t } = useTranslation();
  const [filteredBalloons, setFilteredBalloons] = useState([]);
  const [lastValidResults, setLastValidResults] = useState([]);
  const [lastSearch, setLastSearch] = useState("");

  const addSelected = (item) => {
    if (selected.some((selectedItem) => selectedItem.id === item.id)) {
      return Alert.error("Balloon already selected");
    }
    setSelected((prevState) => [...prevState, item]);
  };

  const { brandsSelected, handleBrandsChange, clearAllBrands, filteredBrands } =
    useFilterByBrand(filteredBalloons);
  const { sizesSelected, handleSizesChange, clearAllSizes, filteredSizes } =
    useSizeFilter(filteredBalloons);
  const {
    categoriesSelected,
    handleCategoryChange,
    clearAllCategories,
    filteredCategories,
  } = useFilterByCategory(filteredBalloons);

  const options = useMemo(() => {
    let result = lastValidResults;

    const hasBrandFilter = Object.values(brandsSelected).includes(false);
    const hasSizeFilter = Object.values(sizesSelected).includes(false);
    const hasCategoryFilter = Object.values(categoriesSelected).includes(false);

    if (hasBrandFilter) result = filteredBrands;
    if (hasSizeFilter)
      result = result?.filter((item) => filteredSizes.includes(item));
    if (hasCategoryFilter)
      result = result?.filter((item) => filteredCategories.includes(item));

    return result;
  }, [
    lastValidResults,
    brandsSelected,
    filteredBrands,
    sizesSelected,
    filteredSizes,
    categoriesSelected,
    filteredCategories,
  ]);

  const renderFilterOption = (name) => {
    if (brandsSelected[name]) {
      return (
        <Col key={name} xs="auto">
          <SelectedOption
            id={name}
            name={name}
            deleteFilter={handleBrandsChange}
          />
        </Col>
      );
    }

    if (sizesSelected[name]) {
      return (
        <Col key={name} xs="auto">
          <SelectedOption
            id={name}
            name={name}
            deleteFilter={handleSizesChange}
          />
        </Col>
      );
    }

    if (categoriesSelected[name]) {
      return (
        <Col key={name} xs="auto">
          <SelectedOption
            id={name}
            name={name}
            deleteFilter={handleCategoryChange}
          />
        </Col>
      );
    }

    return null;
  };

  const filtersObject = {
    ...brandsSelected,
    ...sizesSelected,
    ...categoriesSelected,
  };

  return (
    <Row className="m-0 p-0">
      {/* <Row className="mt-2">
        {selected.map((option, index) => (
          <SelectedOption
            key={index}
            id={option.id}
            displayName={option.displayName}
            name={option.name}
            selected={selected}
            setSelected={setSelected}
          />
        ))}
      </Row> */}
      <Col xs={12}>
        <SearchBar
          lastSearch={lastSearch}
          setLastSearch={setLastSearch}
          setLastValidResults={setLastValidResults}
          setFilteredBalloons={setFilteredBalloons}
        />
      </Col>
      <Row>
        <Col xs={12}>
          {lastValidResults?.length > 0 && (
            <>
              <Row className="p-0 m-0 justify-content-lg-start">
                <p className={`mt-4 p-0 ${style.resultsCount}`}>
                  {options.length} {t("Results for")} "{lastSearch}"
                </p>
                <Col xs="auto" className="p-0 pe-lg-3">
                  <FilterByBrand
                    brandsSelected={brandsSelected}
                    handleChange={handleBrandsChange}
                    clearAll={clearAllBrands}
                    variant="light"
                    customClass={style.filters}
                    userPro={userPro}
                    insertModal={insertModal}
                  />
                </Col>
                <Col xs="auto" className="p-0 pe-lg-3">
                  <FilterBySize
                    sizesSelected={sizesSelected}
                    handleChange={handleSizesChange}
                    clearAll={clearAllSizes}
                    variant="light"
                    customClass={style.filters}
                    userPro={userPro}
                    insertModal={insertModal}
                  />
                </Col>
                <Col xs="auto" className="p-0 pe-lg-3">
                  <FilterByCategory
                    categoriesSelected={categoriesSelected}
                    handleChange={handleCategoryChange}
                    clearAll={clearAllCategories}
                    variant="light"
                    customClass={style.filters}
                    userPro={userPro}
                    insertModal={insertModal}
                  />
                </Col>
              </Row>
              <Row className="justify-content-between">
                <Col xs={10}>
                  <Row>
                    {Object.keys(filtersObject)
                      .filter((name) => filtersObject[name])
                      .map((name) => renderFilterOption(name))}
                  </Row>
                </Col>
              </Row>
            </>
          )}
          {lastValidResults?.length > 0 && (
            <Row className={`m-0 my-2 ${style.optionsContainer}`}>
              {options?.map((balloon) => (
                <Col
                  key={balloon.id}
                  xs={12}
                  className={`my-2 ${style.hoverItem}`}
                >
                  <ViewDetailsRow
                    item={balloon}
                    addToList
                    addColor={addSelected}
                    selected={selected}
                  />
                </Col>
              ))}
            </Row>
          )}
        </Col>
      </Row>
    </Row>
  );
};

export default Filters;
